module.exports = __webpack_public_path__ + "img/refresh-2.62ae61ae.svg";